@if(isImageView && avatarUrl){
<img [src]="avatarUrl" [ngClass]="CSSClass"
  class="d-flex align-items-center justify-content-center white-text rounded-circle fw-bold profile-icon"
  (error)="errorLoadImage()" />
}
@else {
<span class="d-flex align-items-center justify-content-center white-text rounded-circle fw-bold profile-icon"
  [ngClass]="CSSClass" [ngStyle]="{'background-color': randomColor}">
  <span [ngStyle]="{'color': fontColor}">{{characters | uppercase}}</span>
</span>
}